// extracted by mini-css-extract-plugin
export default {"textIconGroupList":"TextIconGroupList_textIconGroupList__O4hr+","textIconGroup":"TextIconGroupList_textIconGroup__bZBDv"};